import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import type { Lead } from '../types/leads';

export function exportLeadsToCSV(leads: Lead[]) {
  // Définir les en-têtes
  const headers = [
    'Type',
    'Valeur',
    'Date',
    'Statut',
    'Message initial'
  ];

  // Préparer les données
  const rows = leads.map(lead => [
    lead.type === 'email' ? 'Email' : 'Téléphone',
    lead.value,
    format(new Date(lead.createdAt), 'dd/MM/yyyy HH:mm', { locale: fr }),
    lead.processed ? 'Traité' : 'Non traité',
    lead.firstMessage.replace(/"/g, '""') // Échapper les guillemets
  ]);

  // Convertir en CSV
  const csv = [
    headers.join(','),
    ...rows.map(row => row.map(cell => `"${cell}"`).join(','))
  ].join('\n');

  // Créer le blob et télécharger
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  
  link.setAttribute('href', url);
  link.setAttribute('download', `leads_${format(new Date(), 'yyyy-MM-dd_HH-mm')}.csv`);
  link.style.visibility = 'hidden';
  
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}